import { AddressFieldsFragment } from "@/gql/graphql";

export function mapAddressToInput(address: AddressFieldsFragment): any {
  return {
    id: address.id,
    city: address.city ?? "",
    state: address.state ?? "",
    postcode: address.postcode ?? "",
    country: address.country ?? "",
    address_line_1: address.address_line_1 ?? "",
    address_line_2: address.address_line_2 ?? "",
  };
}
